import cx from 'classnames';
import Modal from 'components/Modal.jsx';
import React from 'react';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import Text from 'components/Text.jsx';

import './styles/WindowDialog.scss';

type Props = {
  hideCloseButton?: boolean,
};

class WindowDialog extends React.Component {
  props: Props;
  state = {
    closing: false,
  };

  componentDidMount() {
    // push a fake history state to enable back button
    // to only close the modal (and not change navigation).
    window.history.pushState(null, null, null);
  }

  onClose = () => {
    this.setState({ closing: true }, () =>
      setTimeout(this.props.onRequestHide, 300)
    );
  };

  render() {
    const { className, children, ...rest } = this.props;

    return (
      <Modal
        {...rest}
        onRequestHide={this.onClose}
        className={cx('WindowDialog', className, {
          'WindowDialog-closing': this.state.closing,
        })}>
        {
          !this.props.hideCloseButton && (
            <Link
              className="WindowDialog-closeButton"
              onClick={this.onClose}
              eventElementName="WindowDialog-closeButton">
              <div>
                <Glyph color="eclipse" name="close-btn" size="xlarge" solo />
              </div>
              <div className="WindowDialog-closeButton-subtitle">
                <Text
                  className="WindowDialog-closeButton-text"
                  color="eclipse"
                  size="xxxxxsmall"
                  uppercase>
                  Close
                </Text>
              </div>
            </Link>
          )
        }
        {children}
      </Modal>
    );
  }
}

WindowDialog.Content = ({ className, children }) => {
  return (
    <div className={cx('WindowDialog-content', className)}>
      {children}
    </div>
  );
};

/* eslint-disable react/prop-types */
WindowDialog.Header = ({ className, children, border }) => {
  return (
    <div
      className={cx(
      'WindowDialog-header',
      className,
      { 'WindowDialog-header-border': border },
    )}>
      {children}
    </div>
  );
};

WindowDialog.Header.propTypes = {
  border: React.PropTypes.bool,
};

WindowDialog.Header.defaultProps = {
  border: true,
};

WindowDialog.SubHeader = ({ className, children }) => {
  return (
    <div className={cx('WindowDialog-subheader', className)}>
      {children}
    </div>
  );
};

export default WindowDialog;



// WEBPACK FOOTER //
// ./src/components/WindowDialog.jsx